import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { LazyImage } from "./LazyImage";
import { LazyVideoPlayer } from "./LazyVideoPlayer";

export const PostMedia = ({
  media,
  id,
  priority = false,
  edgeToEdge = false,
}) => {
  if (!media?.length) return null;

  // If only one media item, render without Swiper
  if (media.length === 1) {
    const url = media[0];
    const isVideo = /\.(mp4|webm|mov)(\?.*)?$/i.test(url);
    return (
      <div className="post-media" style={{ contain: "content" }}>
        {isVideo ? (
          <LazyVideoPlayer
            key={`video-${id}-0`}
            postId={id}
            src={url}
            priority={priority}
          />
        ) : (
          <LazyImage
            key={`image-${id}-0`}
            src={url}
            priority={priority}
            edgeToEdge={edgeToEdge}
          />
        )}
      </div>
    );
  }

  const handleSwiperClick = (e) => {
    // Prevent event bubbling to parent post
    if (e && typeof e.stopPropagation === "function") {
      e.stopPropagation();
    }
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
  };

  const handleSlideClick = (e) => {
    // Prevent event bubbling to parent post
    if (e && typeof e.stopPropagation === "function") {
      e.stopPropagation();
    }
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
  };

  return (
    <div className="post-media" style={{ contain: "content" }}>
      <div
        onClick={handleSwiperClick}
        // style={{ width: "100%", height: "500px" }}
      >
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={10}
          slidesPerView={1}
          navigation={false}
          pagination={{ clickable: true }}
          className="post-media-swiper"
          style={{ width: "100%", height: "100%" }}
          allowTouchMove={true}
          touchStartPreventDefault={false}
          touchStartForcePreventDefault={false}
          touchMoveStopPropagation={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          speed={1000}
          noSwiping={true}
        >
          {media.map((url, index) => {
            const isVideo = /\.(mp4|webm|mov)(\?.*)?$/i.test(url);
            return (
              <SwiperSlide
                key={`slide-${id}-${index}`}
                onClick={handleSlideClick}
              >
                <div
                  style={{
                    width: "100%",
                    // height: "500px",
                    position: "relative",
                    backgroundColor: "#ffffff",
                  }}
                >
                  {isVideo ? (
                    <LazyVideoPlayer
                      postId={id}
                      src={url}
                      priority={priority}
                    />
                  ) : (
                    <LazyImage src={url} priority={priority} />
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};
